/**
 * Render rich text (HTML) coming from admin RichTextEditor.
 *
 * Backward-compatible: if `html` has no tags (legacy plain text), it gets
 * wrapped in a <p> with whitespace-pre-line so admin's existing line breaks
 * still render.
 *
 * Visual class presets:
 *   - "subtitle"  : muted body copy (used under hero titles)
 *   - "body"      : default reading copy
 *   - "lead"      : larger emphasis copy
 *   - "navy"      : dark navy body (used inside coloured cards)
 *   - "footer"    : light copy on dark footer background
 *   - "snippet"   : compact small caption text
 */
const VARIANTS = {
  subtitle: "prose prose-slate max-w-none text-base sm:text-lg text-ink-muted leading-relaxed prose-strong:text-navy prose-a:text-saffron prose-headings:text-navy prose-headings:font-display prose-headings:font-bold prose-li:my-1",
  body:     "prose prose-slate max-w-none text-base text-ink leading-relaxed prose-strong:text-navy prose-a:text-saffron prose-headings:text-navy prose-headings:font-display prose-headings:font-bold prose-li:my-1",
  lead:     "prose prose-slate max-w-none text-lg sm:text-xl text-ink leading-relaxed prose-strong:text-navy prose-a:text-saffron prose-headings:text-navy prose-headings:font-display prose-headings:font-bold",
  navy:     "prose prose-invert max-w-none text-base text-white/90 leading-relaxed prose-strong:text-white prose-a:text-saffron prose-headings:text-white prose-headings:font-display prose-headings:font-bold",
  footer:   "prose prose-invert max-w-none text-sm text-slate-400 leading-relaxed prose-strong:text-white prose-a:text-saffron prose-headings:text-white",
  snippet:  "prose prose-slate max-w-none text-sm text-ink-muted leading-relaxed prose-strong:text-navy prose-a:text-saffron",
};

export default function RichText({ html, variant = "body", className = "", as: Tag = "div", testid }) {
  const raw = (html || "").trim();
  if (!raw) return null;
  // Treat legacy plain text (no tags) as a paragraph with preserved newlines.
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
  const safe = isHtml
    ? raw
    : `<p style="white-space:pre-line">${raw.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</p>`;
  const cls = `${VARIANTS[variant] || VARIANTS.body} ${className}`.trim();
  return <Tag className={cls} data-testid={testid} dangerouslySetInnerHTML={{ __html: safe }}/>;
}
